import { useConfig } from '../state/hooks.js';
import { useConfigStore } from '../state/store.js';

export function QuantityInput() {
  const config = useConfig();
  const setQuantity = useConfigStore((s) => s.setQuantity);

  return (
    <fieldset className="section">
      <legend className="section-legend">Quantity</legend>

      <div className="quantity">
        <button
          type="button"
          className="quantity__btn"
          aria-label="Decrease quantity"
          onClick={() => setQuantity(config.quantity - 1)}
          disabled={config.quantity <= 1}
        >
          −
        </button>
        <input
          type="number"
          inputMode="numeric"
          min={1}
          max={10000}
          step={1}
          value={config.quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          aria-label="Quantity"
        />
        <button
          type="button"
          className="quantity__btn"
          aria-label="Increase quantity"
          onClick={() => setQuantity(config.quantity + 1)}
          disabled={config.quantity >= 10000}
        >
          +
        </button>
      </div>
    </fieldset>
  );
}
